
  // Opening stays the toggle's click (popovertarget); this only closes.
  const GRACE_MS = 150;

  export default {
    mounted() {
      this.root = this.el.parentElement;
      this.panel = this.root.querySelector("[popover]");
      this.timer = null;

      const isOpen = () => this.panel.matches(":popover-open");
      const hide = () => { if (isOpen()) this.panel.hidePopover(); };

      this.onEnter = () => clearTimeout(this.timer);
      this.onLeave = () => {
        clearTimeout(this.timer);
        // `:hover` matches the root while the pointer is over any DOM
        // descendant, the top-layer panel included.
        this.timer = setTimeout(() => { if (!this.root.matches(":hover")) hide(); }, GRACE_MS);
      };
      this.onFocusOut = (e) => {
        if (this.root.contains(e.relatedTarget) || this.root.matches(":hover")) return;
        hide();
      };
      // One open menu at a time among close-on-leave menus (a row such as
      // the masthead), whatever the browser's popover stacking does. Scoped
      // to menus carrying this hook, so an unrelated Reg.menu elsewhere on
      // the page is left alone.
      this.onToggle = (e) => {
        if (e.newState !== "open") return;
        document.querySelectorAll('.reg-menu:has([phx-hook$="RegMenuCloseOnLeave"]) [popover]').forEach((p) => {
          if (p !== this.panel && p.matches(":popover-open")) p.hidePopover();
        });
      };

      this.root.addEventListener("mouseenter", this.onEnter);
      this.root.addEventListener("mouseleave", this.onLeave);
      this.root.addEventListener("focusout", this.onFocusOut);
      this.panel.addEventListener("toggle", this.onToggle);
    },
    destroyed() {
      clearTimeout(this.timer);
      this.root.removeEventListener("mouseenter", this.onEnter);
      this.root.removeEventListener("mouseleave", this.onLeave);
      this.root.removeEventListener("focusout", this.onFocusOut);
      this.panel.removeEventListener("toggle", this.onToggle);
    }
  }
